import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"
import Slider from "react-slick"
import BackgroundImage from "gatsby-background-image"
import { renderCards } from "../../hooks/usePersonCards"
import Opinion from "./Opinion"

const Dot = styled.a`
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.4);
`

const Box = styled.div`
  padding: 24px 16px;
  &::before {
    content: "";
    position: absolute;
    top: -4px;
    left: 0;
    width: 100%;
    height: 200px;
    background-color: #fffcfa;
    z-index: -1;
  }
  &::after {
    content: "";
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 100%;
    height: 230px;
    background-color: #fffcfa;
    z-index: -1;
  }
  @media (min-width: 768px) {
    &::after,
    &::before {
      height: 220px;
    }
    width: auto;
    padding: 32px 16px;
  }
  @media (min-width: 1024px) {
    padding: 60px 16px;
    &::before {
      height: 320px;
    }
    &::after {
      height: 420px;
    }
  }
  @media (min-width: 1200px) {
    &::after {
      height: 350px;
    }
  }
`

const StyledSection = styled(BackgroundImage)`
  background-position: top top;
  position: relative;
  z-index: 10;
  .slick-track {
    display: flex;
    align-items: flex-end;
    margin-left: 0;
    .slick-slide {
      width: 242px;
      margin-right: 48px;
    }
  }
  .slick-list {
    padding: 0 12px;
  }
  .slick-slider {
    width: 100vw;
    display: block;
    @media (min-width: 768px) {
      display: none;
    }
  }
  .slick-slider.opinion-slider {
    border-radius: 8px;

    @media (min-width: 768px) {
      display: block;
    }
    @media (min-width: 1024px) {
      max-width: 992px;
      margin: 0 auto;
      .slick-list {
        padding: 0;
        margin: 0;
      }
    }
    @media (min-width: 1200px) {
      max-width: 1200px;
    }
    .slick-dots {
      margin-top: 8px;
      transform: translate(-16px, 16px);
      @media (min-width: 1024px) {
        margin-top: 0;
        transform: translate(0, 32px);
        & li {
          margin: 0 35px;
        }
      }
    }
    .slick-active ${Dot} {
      background-color: #000;
    }
    .slick-slide {
      width: 100%;
      @media (min-width: 1024px) {
        /* margin: 0 16px; */
        margin: 0;
        max-width: 1024px;
      }
      @media (min-width: 1200px) {
        max-width: 1200px;
      }
    }
  }

  @media (min-width: 768px) {
    background-size: contain;
    display: flex;
    flex-direction: column;
    padding: 80px 0;
  }
`

const Container = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(3, minmax(auto, 370px));
    grid-column-gap: 15px;
    justify-content: center;
  }
  @media (min-width: 1024px) {
    grid-column-gap: 25px;
    max-width: 992px;
    margin: 0 auto;
  }
  @media (min-width: 1200px) {
    max-width: 1200px;
    grid-column-gap: 50px;
  }
`

const Team = () => {
  const { bgTeam, andrzej, asia, mati } = useStaticQuery(graphql`
    query {
      bgTeam: file(relativePath: { eq: "onas-bg.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      andrzej: file(relativePath: { eq: "clients/andrzej.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      asia: file(relativePath: { eq: "clients/asia.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mati: file(relativePath: { eq: "clients/mati.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
  }
  const settingsOpinions = {
    infinite: true,
    autoplay: true,
    pauseOnHover: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
    dots: true,

    customPaging: () => {
      return <Dot />
    },
  }
  return (
    <StyledSection Tag="section" fluid={bgTeam.childImageSharp.fluid}>
      <Box>
        <Slider {...settings}>{renderCards(true)}</Slider>
        <Container>{renderCards(true)}</Container>
      </Box>
      <Box>
        <Slider {...settingsOpinions} className="opinion-slider">
          <Opinion
            name="Joanna S."
            job="CEO"
            link="http://dotykpiekna.com.pl/"
            opinion="Potrzebowałam wykonać stronę internetową z opisem usług, nigdzie mnie tak nie przyjęli jak w Nis Media. Fachowe porady, przejrzyste zasady współpracy sprawiły, że każdy szczegół dopracowany jest w 100%. Po ukończeniu strony internetowej postanowiłam kontynuować współpracę i zleciłam również reklamę firmy. Serdecznie polecam!"
            company="Dotyk Piękna"
            avatar={asia}
          />
          <Opinion
            name="Andrzej S."
            job="CEO"
            link="http://com-net.com.pl/"
            opinion="Sklep internetowy ruszył jak trzeba, inwestycja zwróciła się po niecałych 2 tygodniach! Panel administracyjny jasno i klarownie wytłumaczony. Z łatwością dodaję produkty do asortymentu. Sklep spełnia również wszystkie standardy i wymogi prawne w Polsce, więc nie miałem dużo na głowie przy publikacji witryny. Polecam Nis Media każdemu!"
            company="Com-Net"
            avatar={andrzej}
          />
          <Opinion
            name="Mateusz B."
            job="CEO"
            link="http://clios.pl/"
            opinion="Zgłosiłem się do Nis Media po utworzenie brandingu mojej firmy. Chłopaki spisali się świetnie, współpraca była bardzo przyjemna, i co najważniejsze - dostałem materiały na czas. W związku z tym postanowiłem powierzyć im jeszcze stronę internetową, czekam na rezultaty, póki co wszystko idzie w dobrym kierunku. Polecam!"
            company="Clios"
            avatar={mati}
          />
        </Slider>
      </Box>
    </StyledSection>
  )
}

export default Team
